import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import withReactContent from 'sweetalert2-react-content';

export const customSwal = withReactContent(Swal).mixin({
    showClass: {
        popup: 'animate-fade-down animate-duration-300 animate-normal'
    },
    hideClass: {
        popup: 'animate-fade-up animate-duration-200 animate-alternate-reverse'
    },
    customClass: {
        title: 'leading-normal',
    }
});

export const modal = withReactContent(Swal).mixin({
    showClass: {
        popup: 'animate-fade-down animate-duration-300 animate-normal'
    },
    hideClass: {
        popup: 'animate-fade-up animate-duration-200 animate-alternate-reverse'
    },
    customClass: {
        title: 'leading-normal',
        popup: 'w-[600px] sm:w-[700px] md:w-[800px] p-6'
    }
});

export const paginationProps = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
};

export const searchByName = (array, nameKey, element = null) => {
    // We going to search the department by name
    let result = array.find((item) => item.name === nameKey);
    // console.log(result, 'searchByName');
    if (element) {
        return result[element];
    }

    return result;
};

export async function getSession() {
    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // window.location = "/";
        return null;
    }
    
    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'me';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        
        let info = {
            email: response.data.user.correo,
            name: response.data.user.nombre_encargado,
            company: response.data.user.nombre_empresa,
            role: response.data.user.tipo_acceso,
            nit: response.data.user.nit_empresa,
            id: response.data.user.id,
        }
        console.log(info, 'getSession success');
        return info;
    } catch (error) {
        console.log(error, 'getSession error');
        // Remove the cookie
        // Cookies.remove("AuthToken");
        // Redirect to login
        // window.location = "/";
        return null;
    }
}

export async function Departamento() {

    let uri = process.env.REACT_APP_API_URL + 'ubicaciones/states_countries/1';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function Municipio(id) {

    let uri = process.env.REACT_APP_API_URL + 'ubicaciones/cities_states/' + id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function Distrito(id) {

    let uri = process.env.REACT_APP_API_URL + 'ubicaciones/districts_cities/' + id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function PuntoCentral(id) {

    let uri = process.env.REACT_APP_API_URL + 'ubicaciones/states/' + id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function EmpresaUsuarios() {

    // if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
    //     // window.location = "/";
    //     return [];
    // }

    let session = Cookies.get("AuthToken");
    let data = await getSession() || {};

    let uri = process.env.REACT_APP_API_URL + 'empresasSucursales';

    if (data?.role === "Empresa") {
        uri = process.env.REACT_APP_API_URL + 'empresa/sucursales/filter';
    }

    if (data?.role  === "Sucursal") {
        return [
            {
                id: data.id,
                nombre_empresa: data.company,
                nit_empresa: data.nit
            }
        ];
    }
    // console.log(data);
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function Empresa() {

    let uri = process.env.REACT_APP_API_URL + 'empresasSucursales';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function DatosGenerales() {

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'count/general';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function DatosEmpresas() {

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'count/formulariosEmp';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export function formatHijosData(data) {
    let obj = {};

    for (let key in data) {
        let match = key.match(/_(\d+)$/);

        if (match) {
            let index = match[1];

            if (!obj[index]) {
                obj[index] = {};
            }

            let newKey = key.replace(/_(\d+)$/, "");
            obj[index][newKey] = data[key];
        }
    }

    return Object.values(obj);
}

export async function DetallesCapis() {

    // let navigate = useNavigate();

    // if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
    //     // navigate("/")    
    //     window.location = "/";
    //     return [];
    // }

    // let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'capis/filter';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            // 'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function DetallesEmpresas() {

    // let navigate = useNavigate();

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'empresas';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function DetallesSucursales() {

    // let navigate = useNavigate();

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'empresa/sucursales';

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function DetallesColaboradores() {

    // let navigate = useNavigate();

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let userInformation = await getSession();
    
    let uri = process.env.REACT_APP_API_URL + 'empresa/colaboradores/' + userInformation?.nit;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function ModificarCapis(id) {
    let currentSession = await getSession();

    if (currentSession === null) {
        window.location = "/";
        return [];
    };

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'admin/capis/'+id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function ModificarEmpresas(id) {

    // let navigate = useNavigate();

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'admin/usuarios/'+id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function ModificarSucursales(id) {

    // let navigate = useNavigate();

    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'empresa/sucursales/' + id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function CapisDepartamento(id) {

    // let navigate = useNavigate();

    // if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
    //     // navigate("/")    
    //     window.location = "/";
    //     return [];
    // }
    
    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'capisDeptData/'+id;
    console.log(uri, 'CapisDepartamento');
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function CapiSeleccionado(id_autorizacion) {

    // let navigate = useNavigate();

    // if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
    //     // navigate("/")    
    //     window.location = "/";
    //     return [];
    // }

    // let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'capis/'+id_autorizacion;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            // 'Authorization': `Bearer ${session}`
        }
    };

    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export async function ModificarColaborador(id){
    if (Cookies.get("AuthToken") === undefined || Cookies.get("AuthToken") === null) {
        // navigate("/")    
        window.location = "/";
        return [];
    }

    let session = Cookies.get("AuthToken");
    let uri = process.env.REACT_APP_API_URL + 'empresa/colaboradores/info/' + id;

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${session}`
        }
    };
    
    try {
        let response = await axios({
            method: 'GET',
            url: uri,
            headers: config.headers
        });
        
        return response.data.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export const checkEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
};

export const getCookie = () => {
    if (!Cookies.get("AuthToken")) {
        return false;
    }
    return Cookies.get("AuthToken");
}

// export const validateSession = () => {
//     let token = Cookies.get(import.meta.env.VITE_APP_TOKEN);

//     if (token === undefined || token === null) {
//         window.location = "/Login";
//         return null;
//     }

//     let parsedToken = (token);

//     return {
//         token: parsedToken,
//         role: parsedToken.role,
//         type: parsedToken.type,
//         data: parsedToken.data,
//     };
// };

export const getOrDeleteRequest = async (action, method, responseType = null, auth = true) => {
    let uri = `${process.env.REACT_APP_API_URL}${action}`;

    let config = {
        method: method,
        url: uri,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };

    if (auth) {
        let session = Cookies.get("AuthToken");

        config.headers['Authorization'] = `Bearer ${session}`;

        config.url = uri;
    }

    if (responseType !== null) {
        config.responseType = responseType;
    }

    try {
        const response = await axios(config);

        if (Array.isArray(response.data)) {
            return response.data;
        }

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

export const postOrPutRequest = async (action, method, data, auth = true, onUploadProgress = null) => {
    let config = {
        headers: {
            'Content-Type': (method.toLowerCase() === 'post') ? 'multipart/form-data' : 'application/json',
            'Accept': 'application/json',
        }
    };

    let uri = `${process.env.REACT_APP_API_URL}${action}`;

    // if (auth && location.pathname !== "/Login" && !regex.test(location.pathname)) {

    //     let session = validateSession();

    //     config.headers['Authorization'] = `Bearer ${decryptData(session.token)}`;
    // }

    try {
        const response = await axios({
            method: method,
            url: uri,
            data: data,
            headers: config.headers,
            onUploadProgress: onUploadProgress
        });

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

// export const getRole = () => {
//     if (Cookies.get(import.meta.env.VITE_APP_USER) === undefined) {
//         // Si no existe la cookie, redireccionamos al login
//         window.location = "/Login";
//         return;
//     }

//     // Si existe la cookie, retornamos el rol
//     return JSON.parse(decryptData(Cookies.get(import.meta.env.VITE_APP_USER))).type_id;
// };


